<template>
  <div
    v-if="selectedDepartments.length !== 0"
    class="department-filter-tags"
  >
    {{ $tm('statistic.filter.selectedDepartments') }}：
    <div :style="{ display: 'inline-block' }">
      <a-tag
        v-for="department in departments"
        :key="department.id"
      >
        <a-space class="space-flex">
          {{ department.name }}
          <IconFont
            v-if="departments.length > 1"
            type="iconguanbi-2"
            :style="{ display: 'block' }"
            @click="$emit('delete', department.id)"
          />
        </a-space>
      </a-tag>
      <a-tag
        v-if="isMoreVisible"
        :style="{ cursor: 'pointer' }"
        @click="$emit('view-more')"
      >
        {{ $tm('statistic.filter.more') }}
      </a-tag>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'DepartmentTagList',
  components: {},
  props: {
    selectedDepartments: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  emits: [
    'delete',
    'view-more'
  ],
  setup (props) {
    const departments = computed(() =>
      props.limit === 0
        ? props.selectedDepartments
        : props.selectedDepartments.slice(0, props.limit)
    )
    const isMoreVisible = computed(() =>
      props.limit !== 0 && props.selectedDepartments.length > props.limit
    )

    return {
      departments,
      isMoreVisible
    }
  }
})
</script>
